module.exports = __webpack_public_path__ + "img/r6.2341ab03.png";